<template>
    <div class="home-search-left">

        <div class="wxapp-qrcode gzh" style="z-index: 3;">
          <div><img :src="gzhImgUrl" alt=""></div>
          <span>公众号</span>
        </div>

        <div class="wxapp-qrcode qrcode" style="z-index: 2;">
          <div><img :src="codeImgUrl" alt=""></div>
          <span>小程序</span>
        </div>

        <client-share v-if="isClient"></client-share>
    </div>
</template>

<script>
import {CheckLibs} from '@digital-supply-chain/module'
import {DomainService} from '@/libs'

import ClientShare from "./client-share.vue";

export default {
    data() {
        return {
            isClient: CheckLibs.isClient(),
            codeImgUrl: `${DomainService.PublicPath}resource/images/dggj.png`,
            gzhImgUrl: `${DomainService.PublicPath}resource/images/gzh.jpg`,
        }
    },
    components: {ClientShare},
}
</script>

<style lang="less" scoped>
    .home-search-left{
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        left: -60px;
        z-index: 1000;
        .wxapp-qrcode{
            width: 60px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            color: #0989C5;
            line-height: 18px;
            cursor: pointer;
            outline: none;
            position: relative;
            &>div{
                height: 34px;
            }
            img{
                width: 30px;
                height: 30px;
                position: absolute;
                transition: all 0.6s;
                top: 0;
            }
            &.qrcode{
                img{
                    left: 30px;
                    margin-left: -15px;
                }
            }
            &.gzh{
                img{
                    right: 30px;
                    margin-right: -15px;
                }
            }
            &:hover{
                img{
                    width: 120px;
                    height: 120px;
                    background-color: #ffffff;
                }
            }
        }
    }
</style>
